/*----- Core -----*/
import React       from 'react'
import { connect } from "react-redux"

/*----- Selectors -----*/
import { emailIsLoadingSelector } from '../Selectors'

/*----- Actions -----*/
import { sendEmail } from '../Actions'

/*----- Components -----*/
import InputContainer from '../../../components/form/InputContainer'
import HandlerButton  from '../../../components/button/HandlerButton'
import Spinner        from '../../../components/commons/Spinner'

/*----- Ant design -----*/
import { Form, Input, Select, InputNumber } from 'antd'
import Paragraph from '../../../components/text/Paragraph'

const  { Option } = Select

function ContactForm({ sendEmail, emailIsLoading }) {
	
  const onFinish = values => sendEmail(values)

	
	if(emailIsLoading) {
		return <Spinner />
	}

	return (
		<Form
			layout				 = "vertical"
			name           =  "contact-form"
			initialValues  = {{ remember: true }}
			onFinish       = {onFinish}
		>

		<Paragraph content="Acerca de tu consulta" bold />

		<InputContainer>
			<Form.Item
				label       = "¿Sos productor o productora?"
				name			  = "service_type"
				rules				= {[{ required: true, message: 'ingresa una opcion' }]}
			>
				<Select
					style				 = {{ width: '100%' }}
					placeholder  = "Tipo de consulta"	
				>
					<Option value="Si">Si</Option>
					<Option value="No">No</Option>
				</Select>
			</Form.Item>
		</InputContainer>


		<Paragraph content="Completá tus datos" bold />

		<InputContainer>
			<Form.Item
				label	=	"Nombre"
				name 	=	"name"
				rules	=	{[{'required': true}]}
			>
				<Input size="large" placeholder="Nombre"/>
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Apellido"
				name 	=	"lastname"
				rules	=	{[{'required': true}]}
			>
				<Input size="large" placeholder="Nombre"/>
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Celular"
				name 	=	"phone_number"
				rules	=	{[{'required': true}]}
			>
				<InputNumber style={{width: '100%'}} size="large" placeholder="Número de celular" />
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Email"
				name 	=	"email"
				rules	=	{[{'required': true, 'type': 'email'}]}
			>
				<Input size="large" placeholder="Email"/>
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Mensaje"
				name 	=	"message"
			>
				 <Input.TextArea autoSize={{ minRows: 6, maxRows: 6 }}  placeholder="Mensaje"/>
			</Form.Item>
		</InputContainer>
		
		<InputContainer>
			<Form.Item className="button-container">
				<HandlerButton content="Enviar" tmlType="submit"/>
			</Form.Item>
		</InputContainer>

	</Form>
	)
}

const mapStateToProps = (state) => {
  return {
		emailIsLoading: emailIsLoadingSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		sendEmail: (params) => sendEmail(dispatch, params)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactForm)
